import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '../../../common/Dialog'
import actions from '../../../../actions'
import { routes } from '../../../../consts'
import $t from '../../../../i18n'
import './JoinVideoDialog.css'

const JoinVideoCallDialog = () => {
  const dispatch = useDispatch()
  const enableDialog = useSelector(
    state => state.videoCall.isVideoPromptVisible
  )
  const otherParticipant = useSelector(
    state => state.videoCall.otherVideoParticipant
  )
  const renderJoinButton = () => {
    const onJoinClick = () => {
      dispatch(actions.createAction(actions.NAVIGATED_TO, routes.VIDEO_CALL))
      dispatch(actions.createAction(actions.VIDEO_CALL_DIALOG_VISIBLE, false))
    }
    return (
      <Button
        data-name="Join Call"
        type="primary"
        onClick={onJoinClick}
        className="trackable"
      >
        {$t('joinCallDialog.join')}
      </Button>
    )
  }
  const renderJoinDialogText = () => {
    return (
      <div className="join-dialog-message">
        <p>
          {$t('joinCallDialog.message') + otherParticipant?.name},
          {' ' + otherParticipant?.speciality}
        </p>
        {$t('joinCallDialog.disclaimer')} <br />
      </div>
    )
  }
  const renderTitle = () => {
    return (
      <h3 className="join-dialog-title">
        {$t('joinCallDialog.title')} <br /> {$t('joinCallDialog.subtitle')}{' '}
      </h3>
    )
  }
  return (
    <>
      <Dialog
        title={renderTitle()}
        isVisible={enableDialog}
        footerActions={renderJoinButton()}
        className={'join-dialog'}
      >
        {renderJoinDialogText()}
      </Dialog>
    </>
  )
}

export default JoinVideoCallDialog
